import React from 'react';

export function SkeletonLine({ width = '100%', height = 12, style }) {
  return (
    <div
      style={{
        width,
        height,
        background: 'var(--bg-tertiary)',
        borderRadius: 4,
        animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
        ...style,
      }}
    />
  );
}

export function SkeletonCard({ style }) {
  return (
    <div
      style={{
        padding: '16px',
        background: 'var(--bg-secondary)',
        borderRadius: 8,
        border: '1px solid var(--border-color)',
        ...style,
      }}
    >
      <SkeletonLine width="60%" height={18} style={{ marginBottom: 12 }} />
      <SkeletonLine width="100%" height={12} style={{ marginBottom: 8 }} />
      <SkeletonLine width="80%" height={12} />
    </div>
  );
}

export function SkeletonClusterCard() {
  return (
    <div
      style={{
        padding: '12px 16px',
        background: 'var(--bg-secondary)',
        borderRadius: 8,
        border: '1px solid var(--border-color)',
      }}
    >
      <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
        <SkeletonLine width="40px" height={40} style={{ borderRadius: 6 }} />
        <div style={{ flex: 1 }}>
          <SkeletonLine width="70%" height={14} style={{ marginBottom: 8 }} />
          <SkeletonLine width="100%" height={12} />
        </div>
      </div>
    </div>
  );
}

export function SkeletonSummaryCard() {
  return (
    <div
      style={{
        padding: '16px',
        background: 'var(--bg-secondary)',
        borderRadius: 8,
        border: '1px solid var(--border-color)',
      }}
    >
      <SkeletonLine width="60%" height={12} style={{ marginBottom: 8 }} />
      <SkeletonLine width="50%" height={24} style={{ marginBottom: 8 }} />
      <SkeletonLine width="70%" height={11} />
    </div>
  );
}

export default SkeletonCard;
